module.exports = __webpack_public_path__ + "img/gibraltar_sq.1e1c2fb8.jpg";